module.exports = __webpack_public_path__ + "static/media/stomachcancer.344d8edd.svg";